<template>
    <div>

        <div class="panel p-2 mt-2" v-for="(route, index) in routes" v-if="route.type == routeType">

            <div class="py-0 font-weight-600 d-flex">
                <div class="activeHover col-sm-8 d-flex align-items-center">
                    <i class="ico mr-2 ml-2 fs-normal pointer dark" :class="{'ico-arrow-bottom': !route.expanded, 'ico-arrow-top': route.expanded}" @click="expandRoute(route)"></i>
                    <input type="text" class="style-underline" v-if="route.editingName " v-model="route.name" @keyup.enter="editRouteName(route)">
                    <span class=" pl-1 d-flex align-items-center" v-else>
                        <span>{{route.name}}</span>
                    </span>
                    <i class="ico ico-edit fs-normal pointer mx-2 dark" :class="{'ico-edit': !route.editingName, 'ico-check': route.editingName, 'withHover': !route.editingName}" @click="editRouteName(route)"></i>
                </div>
                <div class="col-sm-4 text-right">

                    <i class="ico ico-notes mr-3 fs-normal pointer dark" @click="duplicateRoute(routes, index)"></i>
                    <i class="ico ico-delete m-0 fs-normal pointer dark" @click="askDeleteRoute(routes, index)"></i>
                </div>
            </div>

            <div v-if="route.expanded" class="col-sm-12 mt-3 mb-1">
                <table class="w-100" v-if="route.iteneraries && route.iteneraries.length > 0">
                    <thead>
                        <tr class="lightest bg-dark">
                            <th style="width: 40px">&nbsp;</th>
                            <th width="30%"><span class="pl-2">Stop Name</span></th>
                            <th width="auto" class="text-center"><span class="pl-2">Info</span></th>
                            <th class="text-center activeHover" width="100px" v-for="(time,index) in route.iteneraries[0].schedules">
                                <span class="notHover">Time {{index+1}} <i class="ico ico-delete fs-normal m-0"></i></span>
                                <span class="withHover"><i class="ico ico-delete fs-normal pointer m-0" @click="deleteTimeRow(route, index)"></i></span>
                            </th>
                            <th class="text-center" width="50px"><i class="ico ico-timer fs-normal pointer mr-0" @click="addTimeToRoute(route)"></i></th>
                            <th class="text-center" width="20px">&nbsp;</th>
                        </tr>
                    </thead>
                    <draggable v-model="route.iteneraries" :options="draggableOptions" @change="updateStopNr(route)" class="w-100" :element="'tbody'">
                        <tr class="stopRow w-100" v-for="itinerary, index in route.iteneraries" :key="itinerary.id">
                            <!-- <td class="pointer"><span class="pl-2"><span class="lightest bg-dark p-1 radius-normal">{{itinerary.order}}</span> - {{itinerary.stop.name}}</span></td> -->
                            <td class="text-center overflowHidden">
                                <div class="routeMarker radius-circle">
                                    <span class="fs-smaller radius-circle">{{itinerary.order}}</span>
                                </div>
                            </td>
                            <td class=""><v-select class="w-100 d-inline-block align-middle" :options="locationsList" label="name" v-model="itinerary.stop"></v-select></td>
                            <td class="text-center"><input type="text" class="w-100" v-model="itinerary.note"></td>
                            <td class="text-center" v-for="time in itinerary.schedules"><timepicker style="display: inline-flex" @change="changeTime($event, time)" :defaultTime="setTimeToPicker(time.time)"></timepicker></td>
                            <td class="text-center" style="width: 70px;"><span class="dark fs-smaller pointer" @click="addTimeToRoute(route)"><i class="ico ico-add"></i>Add hour</span></td>
                            <td class="text-center"><i class="ico ico-delete m-1 fs-normal pointer dark" @click="removeStop(route.iteneraries, index)"></i></td>
                        </tr>
                    </draggable>
                </table>

                <div class="col-sm-12 text-right my-3">
                    <button class="btn blue mr-3" @click="addStop(route)">
                        + New Location
                    </button>

                    <button class="btn" @click="saveRoute(route)">
                        Save List
                    </button>
                </div>

            </div>

        </div>

        <!-- <div class="bg-darker lightest text-center radius-normal p-1 mt-4 mb-2 fs-large font-weight-600 pointer" @click="addRoute(routeType)">
            Add List
        </div> -->

    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import {mapGetters, mapActions} from 'vuex'
    import Timepicker from '@/tools/Timepicker'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        data: function(){
            return {
                draggableOptions: {
                    draggable:'.stopRow',
                    animation: 200,
                },
                emptySchedule: {
                    //date: "12-12-2018",
                    // id: null,
                    lap: 1,
                    time: "00:00:00",
                    timeShort: "00:00"
                },
                emptyStop: {
                    // id: null,
                    order: 1,
                    note: null,
                    schedules: [],
                    stop: {
                        description: null,
                        // id: null,
                        name: ''
                    }
                },
            }
        },
        props:{
            routes:{
                type: Array
            },
            locationsList:{
                type: Array
            },
            routeType:{
                type: Number
            }
        },
        computed: {
            ...mapGetters([
                'account'
            ])
        },
        methods: {
            ...mapActions([
                'openModal',
                'createRoute',
                'editRoute',
                'deleteRoute',
                'refreshAccountData',
                'startFullScreenLoading',
                'stopFullScreenLoading'
            ]),
            editRouteName: function(route) {
                if(route.editingName !== undefined){
                    route.editingName = !route.editingName
                    if(route.iteneraries.length > 0){
                        this.saveRoute(route)
                    }
                } else {
                    this.$set(route, 'editingName', true);
                }
            },
            expandRoute: function(route) {
                if(route.expanded !== undefined){
                    route.expanded = !route.expanded
                } else {
                    this.$set(route, 'expanded', true);
                }
            },
            removeStop: function(itenerariesArr, index) {
                itenerariesArr.splice(index, 1);
            },
            saveRoute: function(route) {
                if(route.id){
                    //updates existing route
                    this.startFullScreenLoading()
                    this.editRoute(route).then(response => {
                        this.stopFullScreenLoading()
                        if(response.status == 200){
                        }
                    }).catch(error => {
                        this.stopFullScreenLoading()

                    })
                } else {
                    // creates new route
                    this.createRoute(route).then(response => {
                        if(response.status == 200){
                            route.id = response.data.id
                            route.iteneraries = response.data.iteneraries
                            route.routeDestination = response.data.routeDestination
                            route.schedulesDestination = response.data.schedulesDestination
                        }
                    })

                }
            },
            askDeleteRoute: function(routes, index) {
                let vm = this;
                this.$dialog.confirm('Delete route?')
                .then(function () {
                    if(routes[index].id == undefined){
                        routes.splice(index, 1)
                    } else {
                        vm.deleteRoute(routes[index]).then(response => {
                            routes.splice(index, 1)
                        })
                    }
                })
                .catch(function () {
                });
            },
            addTimeToRoute: function(route) {
                for(let itinerary of route.iteneraries){
                    if(itinerary.schedules.length < 5){
                        itinerary.schedules.push(JSON.parse(JSON.stringify(this.emptySchedule)))
                    } else {
                        this.showPopupLimitSchedules()
                        return false
                    }
                }
            },
            showPopupLimitSchedules: function() {
                this.$dialog.alert(('Limit reached'), {okText: 'OK'})
                .then(function () {

                })
                .catch(function () {
                });
            },
            setTimeToPicker: function(timeString) {
                //receives 15:33
                let timeArr = timeString.split(':')
                return timeArr
            },
            changeTime: function(newTime, time) {
                time.time = newTime+":00"
                time.timeShort = newTime
            },
            deleteTimeRow: function(route, index) {
                this.$dialog.confirm('Are you sure you whant to delete the entire column of times?')
                .then(function () {
                    for(let itinerary of route.iteneraries){
                        itinerary.schedules.splice(index, 1)
                    }
                })
                .catch(function () {
                });
            },
            updateStopNr: function(route) {
                route.iteneraries.map((itinerary, index) => {
                    itinerary.order = index + 1
                })
            },
            addStop: function(route) {

                if(route.iteneraries == null){
                    route.iteneraries = []
                }

                let emptyStop = JSON.parse(JSON.stringify(this.emptyStop));
                emptyStop.stop = this.locationsList[0]
                if(route.iteneraries && route.iteneraries.length > 0) {
                    emptyStop.order = route.iteneraries.length + 1;
                    for (var i = 0; i < route.iteneraries[0].schedules.length; i++) {
                        emptyStop.schedules.push(JSON.parse(JSON.stringify(this.emptySchedule)))
                    }
                } else {
                    emptyStop.schedules.push(JSON.parse(JSON.stringify(this.emptySchedule)))
                }
                route.iteneraries.push(emptyStop)
            },
            addRoute: function(routeType) {
                let newRoute = {
                	name: "New List (edit me)",
                	type: routeType, /*Pickup:1 | Dropoff:2*/
                	routeDestination: {
                		// id:int,
                		// name:string,
                		// description:string
                	},
                	iteneraries:
                	[
                		// {
                		// 	id:int,
                		// 	order:int,
                		// 	stop:
                		// 	{
                		// 		id:int,
                		// 		name:string,
                		// 		description:string
                		// 	},
                		// 	schedules:
                		// 	[
                		// 		{
                		// 			id:int,
                		// 			lap:int,
                		// 			time:timeSpan,
                		// 			date: null<datetime>
                		// 		},
                		// 		{...}
                		// 	]
                		// },
                	]
                }

                this.routes.push(newRoute)

            },
            duplicateRoute: function (routes, index) {
                let routeToClone = JSON.parse(JSON.stringify(routes[index]))

                routeToClone.id = null
                routeToClone.expanded = true
                if(!routeToClone.name.startsWith('Copy of ')){
                    routeToClone.name = 'Copy of ' + routeToClone.name
                }

                this.routes.push(routeToClone)
            }
        },
        components: {
            Timepicker,
            draggable,
            vSelect: extendedVSelect
        }
    }
</script>

<style lang="scss" scoped="">
@import '../../../assets/scss/_variables.scss';

.overflowHidden{
    overflow: hidden;
}

table {

    th{
        font-weight: 400;
    }

    .time-picker{
        min-width: 0 !important;
        width: 85px !important;
    }

    tr.stopRow:nth-child(odd){
        background-color: $lighter;
    }
}

tbody .stopRow{
    overflow: hidden;
    cursor: grab;

    &.sortable-ghost{
        cursor: grabbing !important;
    }
}

tbody .stopRow:first-child .routeMarker span::before{display: none}
tbody .stopRow:last-child .routeMarker span::after{display: none}

tbody .stopRow:first-child .routeMarker span{
    // background-color: $color-3 !important;
    box-shadow: 0 0 0 2pt $color-3;

}
tbody .stopRow:last-child .routeMarker span{
    // background-color: $color-6 !important;
    box-shadow: 0 0 0 2pt $color-6;

}

.routeMarker{
    position: relative;
    display: block;
    width: 20px;
    height: 20px;
    z-index: 1;
    margin: auto;

    span{
        position: absolute;
        text-align: center;
        width: 20px;
        height: 20px;
        background-color: $lightest;
        left: 0;
        top: 0;
        padding-top: 2px;
        box-shadow: 0 0 0 2pt $dark;

        &::before, &::after{
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;
            width: 5px;
            height: 2em;
            background: $medium;
            z-index: -1;
        }

        &::before{
            top: -1.5em;
        }
        &::after{
            top: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// RoutesHolder.vue?4690fd74